import { Component, ViewChild, ViewEncapsulation, Input, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { aggregateBy } from '@progress/kendo-data-query';
import { MSCLFilterClass } from '@app/cp/shared/classes/filters/MSCLFilterClass';
import { InventoryQVBus } from '../../shared/models/InventoryQVBus';
import { DateFunctions } from '../../shared/static/date-functions';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { GItem } from '../../shared/models/GItem';
import { DispatchAddPartDialogComponent } from '../dispatch-add-part-dialog/dispatch-add-part-dialog.component';
import { DispatchPage } from '../../shared/models/DispatchPage';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { DispatchPartsBus } from '../../shared/models/DispatchPartsBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
  selector: 'dispatch-qv-parts',
  templateUrl: './dispatch-qv-parts.component.html',
  styleUrls: ['./dispatch-qv-parts.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DispatchQVPartsComponent extends BaseGridEditLineComponent<InventoryQVBus, null, DispatchesService>  {
    supplierNameCF: MSCLFilterClass;
    inventoryNumberCF: MSCLFilterClass;
    orderNumberCF: MSCLFilterClass;
    extraTechs: GItem[] = [];
    showMoveInventory: boolean = false;
    techId: string = null;
    @Input() dispatchPage: DispatchPage;
    curInventoryQVBus: InventoryQVBus;
    @ViewChild('dispatchAddPartDialog') public dispatchAddPartDialog: DispatchAddPartDialogComponent;
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;

        this.className = "v_DispatchPartsOrderedBus";
        this.aggregates = [
            { field: 'amount', aggregate: 'sum' }
        ];
        this.state.group = [{ field: 'amount', aggregates: this.aggregates }];
        this.disableCpSearchDialog();
    }
    rowClassFunction(context: RowClassArgs) {
            if(context.dataItem.isAdded) {
                return { isAdded: true }
            }
            else if(context.dataItem.isUpdated) {
                return { isUpdated: true }
            }
            else if(context.dataItem.inFinance) {
                return { inFinance: true }
            }
    }
    test() {
        this.gridData[0].isAdded = true;
        this.gridData[1].isAdded = true;
        this.gridData[5].isUpdated = true;
        this.gridData[9].isUpdated = true;
        this.goTo("aa",SearchTarget.order)
    }
    showAdd() {
        if (this.canAddEdit && this.dispatchPage && this.dispatchPage.dispatchTrucks && this.dispatchPage.dispatchTrucks.length > 0) { return true;}
        return false;
    }
    processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
            this.supplierNameCF = new MSCLFilterClass('supplierName', 'supplierName', this.gridData);
            this.inventoryNumberCF = new MSCLFilterClass('inventoryNumber', 'inventoryNumber', this.gridData);
            this.orderNumberCF = new MSCLFilterClass('orderNumber', 'orderNumber', this.gridData);
        }
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'id': new UntypedFormControl(),
            'usedPartQuantity': new UntypedFormControl(),

        });

    }
    setForm() {
        this.editForm.patchValue({
            id: this.selectedData.id,
            usedPartQuantity: this.selectedData.usedPartQuantity,
        });
    }
    getChangedObject(data: InventoryQVBus) {
        let busObj: InventoryQVBus = new InventoryQVBus(data);
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setParentId(this._parentId);
        busObj.setBeforeSave();
        return busObj;
    }
    deleteIndividual(data: InventoryQVBus) {
        if (data.hasId) {
            this.svc_data.deleteDispatchPart(data.id).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, dataObj.message);
                }
            });
        }
        else {
            this.closeEditor();
        }
    }

    protected save(data: InventoryQVBus) {
        let busObj: InventoryQVBus = this.getChangedObject(data);

        this.svc_data.saveInventoryQV(busObj).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                let retDataObj: InventoryQVBus = info.dcValues.DataObj;
                if (info.primaryNumber) {
                    this.curInventoryQVBus = busObj;
                    this.extraTechs = info.primaryReturn;
                    this.techId = null;
                    this.showMoveInventory = true;
                    this.cancelHandler();

                }
                if (retDataObj.partType === "From Truck") {

                    retDataObj.quantity = retDataObj.usedPartQuantity
                }
                let dataObj: InventoryQVBus = new InventoryQVBus(retDataObj);
                dataObj = this.setFromReferenceData(dataObj);

                this.removeLocalAdded();
                if (info.dcValues.RefreshNotes == true) {
                    this.doParentAction(this.parentId, "GETPAGEDATA", "DISPATCHNOTES");
                }
                this.saveSuccess(dataObj);
            }
            else {
                this.saveError(info.primaryReturn, info.message);
            }
        });
    }
    closeMoveInventory() {

        this.showMoveInventory = false;

    }

    addPart() {
        this.dispatchAddPartDialog.show(this.dispatchPage.dispatchTrucks);

    }

    confirmAddPart(data: ConfirmOutput) {

        if (data.dialogResult === CPDialogResult.ok) {
            var newPart = this.dispatchAddPartDialog.getNewPart();
            newPart.dispatchId = this.dispatchPage.dispatchId;
            this.saveNewPart(newPart);

        }
    }
    protected saveNewPart(data: DispatchPartsBus) {
        data.dispatchId = this.dispatchPage.dispatchId;
        this.svc_data.saveDispatchParts(data).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {

                let dataObj: InventoryQVBus = new InventoryQVBus(info.primaryReturn);
                this.gridData.push(dataObj);
                this.saveSuccess(dataObj);
            }
            else {
                this.saveError(info.primaryReturn, info.message);
            }
        });
    }

    saveMoveInventory() {

        this.showMoveInventory = false;
        this.curInventoryQVBus.techId = this.techId;
        this.save(this.curInventoryQVBus);

    }
}
